import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

import BulkDebitRequest from "./BulkDebitRequest"
export default function BulkdebitPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="BulkdebitPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('bulkdebit')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div><BulkDebitRequest/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
